import { render, staticRenderFns } from "./YNButtonFlag.vue?vue&type=template&id=2661938a&scoped=true"
import script from "./YNButtonFlag.vue?vue&type=script&lang=js"
export * from "./YNButtonFlag.vue?vue&type=script&lang=js"
import style0 from "./YNButtonFlag.vue?vue&type=style&index=0&id=2661938a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661938a",
  null
  
)

export default component.exports